export const translations = {
    fr: {
        navbar: {
            home: "Accueil",
            portfolio: "Portfolio",
            blog: "Blog",
            contact: "Réseaux"
        },
        hero: {
            subtitle: "Étudiant en Cybersécurité & Aspirant Pentester",
            description: "Étudiant en 1ère année de Mastère à la recherche d’une alternance en Pentest (1 semaine en cours / 3 semaines en entreprise).",
            viewPortfolio: "Voir Portfolio",
            viewBlog: "Voir Blog",
            contactMe: "Reseaux"
        },
        about: {
            title: "Profil Personnel",
            p1: "Jeune étudiant en cybersécurité, passionné par le domaine de la",
            p1_highlight: "sécurité offensive",
            p1_end: "et par l’administration système et réseau.",
            p2: "Déterminé à acquérir les compétences nécessaires pour relever les défis de la cybersécurité, je me forme en autodidacte via HackTheBox (81 machines), PortSwigger, et Root-Me.",
            p3: "Je prépare actuellement un Mastère en Cybersécurité et suis à la recherche d'une alternance pour mettre en pratique mes connaissances."
        },
        skills: {
            title: "Compétences Techniques",
            categories: {
                web: "Pentest Web",
                ad: "Active Directory",
                network: "Réseau & SysAdmin",
                languages: "Langages",
                redteam: "Red Teaming"
            }
        },
        projects: {
            title: "Projets Personnels",
            status: {
                ongoing: "En cours",
                done: "Terminé"
            }
        },
        education: {
            title: "Formations",
            current: "[Actuellement]"
        },
        blog: {
            title: "Blog",
            subtitle: "Articles sur le Pentest et la Cybersécurité.",
            forwardshell: {
                title: "ForwardShell",
                description: "Le shell oublié entre le Reverse, le Bind et le Webshell."
            }
        },
        writeups: {
            title: "Writeups",
            hackthebox: {
                title: "HackTheBox",
                description: "Mes writeup de machines HackTheBox"
            }
        },
        contact: {
            title: "Réseaux"
        }
    },
    en: {
        navbar: {
            home: "Home",
            portfolio: "Portfolio",
            blog: "Blog",
            contact: "Social Network"
        },
        hero: {
            subtitle: "Cybersecurity Student & Aspiring Pentester",
            description: "Master's student looking for a Pentesting apprenticeship (1 week school / 3 weeks work).",
            viewPortfolio: "View Portfolio",
            viewBlog: "View Blog",
            contactMe: "Social Network"
        },
        about: {
            title: "Personal Profile",
            p1: "Cybersecurity student passionate about",
            p1_highlight: "offensive security",
            p1_end: "and system/network administration.",
            p2: "Determined to acquire the necessary skills to face cybersecurity challenges, I am self-taught via HackTheBox (81 machines), PortSwigger, and Root-Me.",
            p3: "I am currently preparing a Master's in Cybersecurity and looking for an apprenticeship to put my knowledge into practice."
        },
        skills: {
            title: "Technical Skills",
            categories: {
                web: "Web Pentest",
                ad: "Active Directory",
                network: "Network & SysAdmin",
                languages: "Languages",
                redteam: "Red Teaming"
            }
        },
        projects: {
            title: "Personal Projects",
            status: {
                ongoing: "Ongoing",
                done: "Completed"
            }
        },
        education: {
            title: "Education",
            current: "[Currently]"
        },
        blog: {
            title: "Blog",
            subtitle: "Pentest and Cybersecurity articles.",
            forwardshell: {
                title: "ForwardShell",
                description: "The forgotten shell between Reverse, Bind and Webshell."
            }
        },
        writeups: {
            title: "Writeups",
            hackthebox: {
                title: "HackTheBox",
                description: "My HackTheBox machine writeups"
            }
        },
        contact: {
            title: "Social Network"
        }
    }
};
